import { AboutActionTypes, CuvvaPeeps, initialAboutState } from '../types';
import createAsyncReducer from '~lib/shared/redux/reducers/async-reducer';

const ListStaffPublicReducer = createAsyncReducer<CuvvaPeeps>(
	AboutActionTypes.LIST_CUVVA_PEEPS,
	initialAboutState.listCuvvaPeeps
);

export default ListStaffPublicReducer;
